import { createApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/vue3'
import { createVfm } from 'vue-final-modal'
import VueSilentbox from 'vue-silentbox'
import VLazyImage from 'v-lazy-image'
import VueSweetalert2 from 'vue-sweetalert2'
import Vue3TouchEvents from 'vue3-touch-events'
import { ZiggyVue } from '../../vendor/tightenco/ziggy/dist/vue.m'
import Head from './components/frontend/Head.vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import translationMixin from './translation'
import utilsMixin from './utils'

library.add(fas, far, fab)

createInertiaApp({
  resolve: name => import(`./pages/${name}`),
  setup({ el, App, props, plugin }) {
    createApp({ render: () => h(App, props) })
      .use(plugin)
      .use(createVfm())
      .use(VueSilentbox)
      .use(VueSweetalert2)
      .use(Vue3TouchEvents)
      .use(ZiggyVue)
      .mixin(translationMixin)
      .mixin(utilsMixin)
      .component('Head', Head)
      .component('v-lazy-image', VLazyImage)
      .component('font-awesome-icon', FontAwesomeIcon)
      .mount(el)
  },
})
